import { GetOfferQuery, FeatureCode } from 'generated/graphql';
import { toOfferData } from '@client/pages/LPBuilder/model/sections/offer.mappers';
import { toOfferPricing } from './OfferPricing.mappers';

export type OfferDetailsData = {
  programIds: { options: Array<{ value: number; label: string }> };
  workoutIds: {
    options: Array<{
      value: number;
      label: string;
      programId: number | null;
      programName: string;
      imgUrl: string;
    }>;
  };
  extrasIds: { options: Array<{ value: string; label: string }> };
  communityFeatures: { options: Array<{ value: FeatureCode; label: string }> };
  price: number | null;
  checkoutUrl: string | null;
};

export const toOfferDetailsData = (data: GetOfferQuery): OfferDetailsData => {
  const offerData = toOfferData(data);
  const pricing = toOfferPricing(data);

  return {
    ...offerData,
    price: pricing.price,
    checkoutUrl: pricing.checkoutUrl,
  };
};
